import { Button } from '@/common/components/Button'
import { LightningIcon, StudentIcon } from '@/common/icons/general'
import { useNavigate } from 'react-router-dom'
import { AppRoutePaths } from '@/routing/route_paths'
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout.tsx'
import { useTranslation } from 'react-i18next'
import { useEffect, useRef } from 'react'
import { LogUserActivity } from '@/apis/users/requests'
import { LOG_TYPES } from '../constants'

export const StudentPrepPage = () => {
  const navigateTo = useNavigate()
  const { t: translate } = useTranslation()

  const hasLoggedPageView = useRef(false);
  useEffect(() => {
    if (!hasLoggedPageView.current) {
      LogUserActivity({
        log_type: LOG_TYPES.VIEW_PAGE,
        suffix_text: 'Student details page',
      })
      hasLoggedPageView.current = true;
    }
  }, []) 

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        <h1>{translate('student_details')}</h1>
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content>
        <p className="text-xl font-medium text-gray-900 mb-10 sm:mb-5">
          {translate('determine_text')}
        </p>
        <section aria-labelledby="what-to-expect">
          <h2 id="what-to-expect" className="sr-only">{translate('what_to_expect')}</h2>
          <div className="flex items-center">
            <StudentIcon aria-hidden="true" />
            <div className="ml-2 font-medium">
              {translate('what_to_expect')}
            </div>
          </div>
          <p className="ml-6 mt-1 text-gray-700 text-sm">
            {translate('answer_a_few_questions')}
          </p>
        </section>
        <section aria-labelledby="what-you-will-need" className="mt-6">
          <h2 id="what-you-will-need" className="sr-only">{translate('what_you_will_need')}</h2>
          <div className="flex items-center">
            <LightningIcon aria-hidden="true" />
            <div className="ml-2 font-medium">
              {translate('what_you_will_need')}
            </div>
          </div>
          <p className="ml-6 mt-1 text-gray-700 text-sm">
            {translate('proof_of_student')}
          </p>
        </section>
      </FamilyWizardLayout.Content>
      <FamilyWizardLayout.ActionBar>
        <Button
          onClick={() => {
            navigateTo(
              AppRoutePaths.family_application.student_details.enter_details
            )
          }}
          className="w-full"
        >
          {translate('continue')}
        </Button>
      </FamilyWizardLayout.ActionBar>
    </FamilyWizardLayout>
  )
}
